import { useState } from 'react';
import { RegisterFormData } from '../types';
import { validatePhoneNumber } from '@/utils/validation';
import { api } from '@/lib/api/client';

export function useRegisterForm() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const onSubmit = async (data: RegisterFormData) => {
    if (isSubmitting) return false;

    // Validate phone number format
    const phoneValidation = validatePhoneNumber(data.phoneNumber);
    if (phoneValidation !== true) {
      setError(typeof phoneValidation === 'string' ? phoneValidation : 'رقم الهاتف غير صحيح');
      return false;
    }

    // Validate password
    if (data.password !== data.confirmPassword) {
      setError('كلمة المرور غير متطابقة');
      return false;
    }

    if (!/[a-zA-z0-9]$/.test(data.password)) {
      setError('يجب أن تتكون كلمة المرور من 4 أرقام فقط');
      return false;
    }

    setIsSubmitting(true);
    setError(null);

    try {
      // Submit registration request
      await api.post('api/auth/register', {
        name: data.name,
        phoneNumber: data.phoneNumber,
        password: data.password,
        fatherName: data.fatherName,
        grandfather1: data.grandfather1,
        grandfather2: data.grandfather2,
        grandfather3: data.grandfather3,
        region: data.region,
        occupation: data.occupation,
        branch: data.branch,
        educationLevel: data.educationLevel === 'other' ? data.otherEducationLevel : data.educationLevel,
        birthDate: data.birthDate,
        gender: data.gender,
        maritalStatus: data.maritalStatus
      });

      setIsSuccess(true);
      return true;
    } catch (error) {
      console.error('Registration error:', error);
      setError(error instanceof Error ? error.message : 'حدث خطأ أثناء تقديم الطلب');
      return false;
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    onSubmit,
    isSubmitting,
    isSuccess,
    error
  };
}